var map = {
	"./drill-btn-clear-inactive.png": 2076,
	"./drill-btn-eraser-active.png": 2676,
	"./drill-btn-eraser-inactive.png": 2357,
	"./drill-btn-pen-active.png": 7755,
	"./drill-btn-pen-inactive.png": 6162,
	"./drill-btn-success-inactive.png": 3682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1048;